// Mapeo de item_code de Frappe a rutas de páginas de productos insignia
export const getInsigniaLink = (id) => {
  const links = {
    'PD0003': '/insignia/Superior',
    'PD0004': '/insignia/UNOR4',
    'PD0005': '/insignia/UNOR3',
    'PD0001': '/insignia/kitsArduino',
    'PD0002': '/insignia/kitsArduino',
  };
  return links[id] ? { success: true, link: links[id] } : { success: false };
};
